import { ref } from 'vue'
import type { ToastType } from '@/components/common/Toast.vue'

// Global toast instance reference
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const toastInstance = ref<any>(null)

export function useToast() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const setToastInstance = (instance: any) => {
    toastInstance.value = instance
  }

  const showToast = (message: string, type: ToastType = 'info', duration = 3000) => {
    if (!toastInstance.value) {
      console.warn('Toast instance not initialized')
      return
    }
    return toastInstance.value.addToast(message, type, duration)
  }

  const info = (message: string, duration?: number) => {
    return showToast(message, 'info', duration)
  }

  const success = (message: string, duration?: number) => {
    return showToast(message, 'success', duration)
  }

  const warning = (message: string, duration?: number) => {
    return showToast(message, 'warning', duration)
  }

  const error = (message: string, duration?: number) => {
    return showToast(message, 'error', duration)
  }

  return {
    setToastInstance,
    showToast,
    info,
    success,
    warning,
    error,
  }
}
